import React from 'react'
import TelegramTasks from '../../Component/adminComp/TelegramTasks'

const AdminTelegramTasks = () => {
  return (
    <div className=''>


    <TelegramTasks/>
   
    </div>
  )
}

export default AdminTelegramTasks;